import { SpecialtyListData } from './SpecialtyListMapper.types'

class SpecialtyListMapper {
  toDomain(persistenceSpecialtyData: SpecialtyListData) {
    return {
      id: persistenceSpecialtyData?.id,
      specialtyName: persistenceSpecialtyData?.nome,
      council: persistenceSpecialtyData?.tipoConselho,
    }
  }
}

export default new SpecialtyListMapper()
